import { render, staticRenderFns } from "./EmailUnsubscribe.vue?vue&type=template&id=50834b1e&"
import script from "./EmailUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./EmailUnsubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports